import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import { act } from "react";

export interface ChatState {
  conversationsChats: [any];
  agencyChats: [any];
  chatUuid: string;
  conversation: any;
  twilioToken: string;
  statusAgent: boolean;
  mediaChat: any;
  templates: [any];
  notes: string;
}

const initialState: ChatState = {
  conversationsChats: <any>[],
  agencyChats: <any>[],
  chatUuid: '',
  conversation: null,
  twilioToken: '',
  statusAgent: false,
  mediaChat: null,
  notes: ''
}

export const chatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    setconversationsChats: (state, action: PayloadAction<any>) => {
      state.conversationsChats = action.payload;
    },
    setAgencyChats: (state, action: PayloadAction<any>) => {
      state.agencyChats = action.payload;
    },
    setChatUuid: (state, action: PayloadAction<any>) => {
      state.chatUuid = action.payload;
    },
    setConversation: (state, action: PayloadAction<any>) => {
      state.conversation = action.payload;
    },
    clearChatData: (state) => {
      state.chatUuid = '';
      state.conversation = null;
    },
    setTwilioToken: (state, action: PayloadAction<any>) => {
      state.twilioToken = action.payload;
    },
    setStatusAgent: (state, action: PayloadAction<any>) => {
      state.statusAgent = action.payload;
    },
    setMediaChat: (state, action: PayloadAction<any>) => {
      state.mediaChat = action.payload;
    },
    setTemplate: (state, action: PayloadAction<any>) => {
      state.templates = action.payload;
    },
    setNotes: (state, action: PayloadAction<any>) => {
      state.notes = action.payload;
    },
  }
});

export const {
  setconversationsChats,
  setAgencyChats,
  setChatUuid,
  setConversation,
  setTwilioToken,
  setStatusAgent,
  clearChatData,
  setMediaChat,
  setTemplate,
  setNotes
} = chatSlice.actions;

export default chatSlice.reducer;
